import { Inject } from '@angular/core';
import { AlpTransferFeeLabels } from '../models/types';
import { BasePriceListBandsService } from './base-pricelist-bands.service';
import { PriceListTransferFee, PriceListTransferFeeProduct } from '../models/pricelist-transfer.model';

@Inject({
  providedIn: 'root',
})
export class PriceListTransferFeeBandsService extends BasePriceListBandsService<PriceListTransferFeeProduct> {
  /**
   * Returns the column labels for the transfer fee table.
   * Example:
   * [
   *   { band: '1-1', header: '1 Person'},
   *   { band: '2-2', header: '2 Persons' },
   * ]
   */
  getColumnLabels(transfers: PriceListTransferFee): AlpTransferFeeLabels {
    const bands = this.getSortedBands(transfers.products);
    const headerColumns = this.getHeaderColumnsWithBands(bands, {
      singular: 'Person',
      plural: 'Persons',
    });
    return {
      product: 'Destination',
      peopleLabels: headerColumns,
    };
  }
}
